import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled", "onClick"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBack = _resolveComponent("SharedBack")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedCard = _resolveComponent("SharedCard")!

  return (_openBlock(), _createBlock(_component_SharedCard, {
    class: _normalizeClass(_ctx.b())
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createVNode(_component_SharedBack, { onClick: _ctx.handleBack }, null, 8, ["onClick"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('header-content'))
        }, [
          _createElementVNode("h3", {
            class: _normalizeClass(_ctx.b('title'))
          }, _toDisplayString(_ctx.$t("Верификация информации о компании")), 3),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('subtitle'))
          }, _toDisplayString(_ctx.$t("Пройдите три блока — порядок любой, данные сохраняются")), 3)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('content'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('list'))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedList, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(_ctx.b('item', { padding: item.isPadding })),
              key: item.id,
              disabled: item.isDisabled,
              onClick: ($event: any) => (_ctx.handleContinue(item))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('item-icon', { success: item.isSuccess })),
                innerHTML: item.icon
              }, null, 10, _hoisted_2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('item-info'))
              }, [
                _createElementVNode("h4", {
                  class: _normalizeClass(_ctx.b('item-title'))
                }, _toDisplayString(_ctx.$t(item.title)), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('item-label'))
                }, _toDisplayString(_ctx.$t(item.label)), 3)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('item-chevron')),
                innerHTML: _ctx.displayedSvg.chevron
              }, null, 10, _hoisted_3)
            ], 10, _hoisted_1))
          }), 128))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('verification-block'))
        }, [
          _createVNode(_component_UIButton, {
            class: _normalizeClass(_ctx.b('verification')),
            label: _ctx.displayedVerificationLabel,
            view: "main",
            disabled: _ctx.isVerificationDisabled,
            onClick: _ctx.handleVerification
          }, null, 8, ["class", "label", "disabled", "onClick"]),
          (_ctx.isVerificationDisabled && !_ctx.isReadonly)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(_ctx.b('verification-hint'))
              }, _toDisplayString(_ctx.$t(
              "Кнопка станет активной, когда все обязательные блоки будут отмечены галочкой"
            )), 3))
            : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}